import React from 'react';
import HotelRoundedIcon from '@material-ui/icons/HotelRounded';
import GenericDetail from 'gui/components/listPage/components/ad/components/genericDetail';

interface IAdRoomsAmountProps {
  roomsAmount: number;
}

const AdRoomsAmount = (props: IAdRoomsAmountProps) => (
  <GenericDetail
    title="מספר חדרים"
    icon={HotelRoundedIcon}
  >
    {props.roomsAmount}
  </GenericDetail>
);

AdRoomsAmount.defaultProps = {
  roomsAmount: 1,
};
export default AdRoomsAmount;
